import script from "./MainMenuAuthComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./MainMenuAuthComponent.vue?vue&type=script&setup=true&lang=js"

import "./MainMenuAuthComponent.vue?vue&type=style&index=0&id=522795d1&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-522795d1"]])

export default __exports__